<h2 mat-dialog-title>Title</h2>
<mat-dialog-content>
  <mat-form-field>
    <input matInput [formControl]="nameField" required>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [matDialogClose]="title" type="submit">OK</button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
